// Which state the Settings "subscription" row is in. Pure so it can be unit-tested.
import type { StripeSubscriptionStatus } from '@/services/sync';

export type SubscriptionRowKind =
  | 'store'          // Apple / Google: cancel in the store
  | 'org'            // access provided by an organisation
  | 'cancel'         // Stripe, recurring, still renewing: show the Cancel button
  | 'cancelled'      // Stripe, recurring, already set to end
  | 'no-renew'       // Stripe, nothing recurring
  | 'loading'        // Stripe, status unknown yet and plan unknown: neutral
  | 'check-failed'   // Stripe, status call failed and plan unknown
  | 'active'         // Stripe, no server session to ask and plan unknown: neutral "active"
  | 'none';

/** status: undefined = still loading, null = the check failed, object = server answer. */
export function subscriptionRowState(
  source: string | null | undefined,
  plan: 'monthly' | 'annual' | null | undefined,
  status: StripeSubscriptionStatus | null | undefined,
  canCheck = true,
):  SubscriptionRowKind {
  if (source === 'apple' || source === 'google') return 'store';
  if (source === 'org') return 'org';
  if (source !== 'stripe') return 'none';
  if (status) {
    if (!status.hasRecurring) return 'no-renew';
    return status.cancelAtPeriodEnd ? 'cancelled' : 'cancel';
  }
  // Loading or failed: fall back to the plan, but never claim "doesn't renew" for an unknown plan.
  if (plan === 'monthly') return 'cancel';
  if (plan === 'annual') return 'no-renew';
  if (!canCheck) return 'active';
  return status === null ? 'check-failed' : 'loading';
}
